import { Spin } from 'antd';
import download from 'downloadjs';
import React, { useState } from 'react';
import { GrFormNext } from 'react-icons/gr';
import { MdOutlineFileDownload } from 'react-icons/md';
import Apis from '../../../api';
import { DataRoom } from '../../main/deals/redux/types';

type Props = {
    breadCrumbs: DataRoom[];
    breadCrumbsClick: (data: DataRoom, index: number) => void;
    isDownload: boolean;
    rootUUID: string | undefined;
    isDeal: boolean;
    setInvestmentDoc?: (s?: string) => void;
};

const BreadCrumbs: React.FC<Props> = ({
    breadCrumbs,
    breadCrumbsClick,
    isDownload,
    rootUUID,
    isDeal,
    setInvestmentDoc,
}) => {
    const [loading, setLoading] = useState(false);

    const onClickDownloadZip = (obj: DataRoom) => {
        try {
            if (rootUUID) {
                Apis.analyticsTrackStart(obj.dealUUID, rootUUID, 'DownloadZip');
                setLoading(true);
                Apis.downloadZipFile(obj.dealUUID, obj.group, rootUUID)
                    .then(({ data }) => {
                        download(data, `${obj.dealUUID}.zip`);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        } catch (err) {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-between items-center pt-6">
            <div className={isDeal ? 'w-4/5' : 'w-full'}>
                {!setInvestmentDoc && (
                    <nav className=" rounded-lg" aria-label="Breadcrumb">
                        <ol className="space-x-1 md:space-x-3">
                            {breadCrumbs.map((b, index) => (
                                <li
                                    className="inline-flex items-center"
                                    key={`dataRoom_bread_${b.group}_${index}`}
                                    onClick={() => breadCrumbsClick(b, index)}
                                    style={index !== 0 ? { marginLeft: '4px' } : {}}
                                >
                                    {index === 0 && (
                                        <span
                                            className="text-[#142C53] text-2xl font-[WorkSans-Semibold] uppercase font-bold  my-1.5 common_read_title"
                                            style={{ top: '-4px' }}
                                        >
                                            {b.name}
                                        </span>
                                    )}
                                    {index !== 0 && (
                                        <span
                                            className="inline-flex items-center cursor-pointer lg:text-base font-semibold my-1.5 common_read_title"
                                            style={{ color: 'rgb(24, 45, 79)' }}
                                        >
                                            <GrFormNext
                                                className="mr-1 md:mr-1 relative"
                                                size="1.2rem"
                                                style={{ top: '1px' }}
                                            />
                                            {b.name}
                                        </span>
                                    )}
                                </li>
                            ))}
                        </ol>
                    </nav>
                )}
                {setInvestmentDoc && (
                    <nav
                        className="py-1 pt-2 px-2 lg:px-4"
                        aria-label="Breadcrumb"
                        style={{ backgroundColor: '#F5F4F2' }}
                    >
                        <li className="inline-flex items-center">
                            <span
                                className="inline-flex mr-1 items-center text-sm font-semibold my-1.5 common_read_title cursor-pointer relative"
                                style={{ top: '-4px', color: '#404040' }}
                                onClick={() => setInvestmentDoc(undefined)}
                            >
                                Documents
                            </span>
                            <span
                                className="inline-flex items-center text-sm font-semibold my-1.5 common_read_title cursor-pointer relative"
                                style={{ top: '-4px' }}
                            >
                                <GrFormNext
                                    className="mr-1 md:mr-1 relative"
                                    color="#26AE60"
                                    size="1.2rem"
                                    style={{ top: '1px' }}
                                />
                            </span>
                        </li>
                        {breadCrumbs.map((b, index) => (
                            <li
                                className="inline-flex items-center"
                                key={`dataRoom_bread_${b.group}_${index}`}
                                onClick={() => breadCrumbsClick(b, index)}
                                style={index !== 0 ? { marginLeft: '4px' } : {}}
                            >
                                {index === 0 && (
                                    <span
                                        className="inline-flex text-[#B1C1D4] items-center text-sm font-semibold my-1.5 common_read_title cursor-pointer relative"
                                        style={{ top: '-4px' }}
                                    >
                                        {b.name}
                                    </span>
                                )}
                                {index !== 0 && (
                                    <span className="inline-flex items-center cursor-pointer text-sm font-semibold my-1.5 common_read_title">
                                        <GrFormNext
                                            className="mr-1 md:mr-1 relative"
                                            size="1.2rem"
                                            color="#26AE60"
                                            style={{ top: '1px' }}
                                        />
                                        {b.name}
                                    </span>
                                )}
                            </li>
                        ))}
                    </nav>
                )}
            </div>
            {isDeal && (
                <div className="md:w-1/5 py-2 px-1 rounded-lg">
                    {isDownload &&
                        breadCrumbs[breadCrumbs.length - 1] &&
                        breadCrumbs[breadCrumbs.length - 1].group === 'DataRoom' && (
                            <div
                                className="flex justify-end items-center cursor-pointer  transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110  duration-300"
                                onClick={() => {
                                    if (!loading) {
                                        onClickDownloadZip(breadCrumbs[breadCrumbs.length - 1]);
                                    }
                                }}
                            >
                                {!loading && (
                                    <>
                                        <span
                                            className="text-sm uppercase font-[WorkSans-Semibold] font-bold relative "
                                            style={{ top: '-1px' }}
                                        >
                                            Download
                                        </span>
                                        <MdOutlineFileDownload className="ml-1 text-[#13974B]" size={'1.4rem'} />
                                    </>
                                )}
                                {loading && <Spin size="small" />}
                            </div>
                        )}
                </div>
            )}
        </div>
    );
};

export default BreadCrumbs;
